import { useEffect, useRef } from "react";
import useCallsStore from "../hooks/useCallsStore";
import { CallsLogger } from "../helpers";

type RemoteStreamViewProps = { userID?: number; mirror?: boolean } & React.VideoHTMLAttributes<HTMLVideoElement>;

const RemoteStreamView: React.FC<RemoteStreamViewProps> = ({ userID, mirror = false, style = {}, ...props }) => {
  const remoteStreams = useCallsStore((store) => store.remoteStreams);
  const remoteStream = userID && remoteStreams[userID];
  const videoRef = useRef<HTMLVideoElement>(null);
  const elementId = `ConnectyCubeMediaStream-${userID}`;
  const cssProps: React.CSSProperties = {
    transform: mirror ? "scaleX(-1)" : "none",
    objectFit: "contain",
    height: "100%",
    width: "100%",
    ...style,
  };

  useEffect(() => {
    if (videoRef.current && remoteStream) {
      videoRef.current.srcObject = remoteStream;
      videoRef.current.onloadedmetadata = () => {
        try {
          videoRef.current?.play();
        } catch (error) {
          CallsLogger.error("<RemoteStreamView/> play()", error);
        }
      };
    }
  }, [remoteStream]);

  return remoteStream ? <video autoPlay playsInline ref={videoRef} id={elementId} style={cssProps} {...props} /> : null;
};

export default RemoteStreamView;
